export default __webpack_public_path__ + "static/media/MoonEarrings.d922fb41.jpg";